import { put, call, takeEvery } from 'typed-redux-saga';

import DashboardGateway from '~apis/dashboard';

import { store } from '~redux/store';
import combinedActions from '~redux/combinedActions';
import { ErrorMessages } from '~utils/constants';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { PayloadAction } from '@reduxjs/toolkit';
import { TGetDashboardProductInventoryFilters } from '~types/feat/dashboard';

export default function* watchGetDashboardProductInventory(api: DashboardGateway): SagaWatcherReturnType {
    yield takeEvery('dashboard/dashboardGetDashboardProductInventoryAttempt', handleGetDashboardProductInventory, api);
}

function* handleGetDashboardProductInventory(
    api: DashboardGateway,
    action: PayloadAction<TGetDashboardProductInventoryFilters>
) {
    const reduxState = store.getState();

    const authToken = reduxState.auth.userDetails.authToken;

    const { branchName, ...filters } = action.payload;

    const response = yield* call(
        [api, api.getDashboardProductInventory],
        {
            authToken,
            ...filters,
        }
    );

    if (response.status === GatewayResponseStatus.Error) {
        yield put(
            combinedActions.dashboardGetDashboardProductInventoryFailure(
                response.message || ErrorMessages.GenericError
            )
        );

        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(
            combinedActions.dashboardGetDashboardProductInventorySuccess({
                data: response.data,
                metalType: action.payload.metalType,
            })
        );
    }
}
